import React, { useContext } from 'react';
import { ShowFrontEndContext } from './types';
import { useTranslation } from 'react-i18next';
import { pageDirContext } from '../../App';

const OurWork: React.FC = () => {
  const { NosServicesRef } = useContext(ShowFrontEndContext);
  const { t } = useTranslation();
  
  const { pageDir } = useContext(pageDirContext)
  
  return (
    <section className="flex justify-center items-center py-12 px-4" ref={NosServicesRef} dir={pageDir}>
      <div className="flex flex-col md:flex-row items-center justify-between w-full max-w-7xl">
        
        {/* Left Section - Image */}
        <div className="relative flex-1 mb-8 md:mb-0">
          <img
            src="/assets/images/our-work-image.jpg"
            alt={t("Our Work")}
            className="w-full h-auto rounded-lg transition-transform duration-500 ease-in-out transform hover:scale-105 hover:rotate-3 hover:shadow-xl hover:shadow-indigo-500/50"
          />
        </div>

        {/* Right Section - Information */}
        <div className={`flex-1 text-center ${pageDir === 'rtl' ? "md:text-right mr-10" : "md:text-left ml-10"}`} dir={pageDir}>
          <h2 className="text-2xl font-bold text-main mb-4">{t("Nos Services")}</h2>
          <p className="text-gray-700 mb-4">
            {t("À l'ONMDM, nous nous efforçons de fournir des services exceptionnels dans le domaine dentaire, en travaillant sans relâche pour améliorer la santé bucco-dentaire des Mauritaniens.")}
          </p>
          <p className="text-gray-700 mb-6 hover:fade">
            {t("Notre équipe est composée de professionnels hautement qualifiés, engagés à faire progresser les soins dentaires et les services grâce à des pratiques innovantes et des technologies de pointe.")}
          </p>
          <button className="bg-main text-white py-2 px-4 rounded-lg transition-all duration-300 hover:bg-indigo-600">
            {t("En savoir plus")}
          </button>
        </div>
      </div>
    </section>
  );
};

export default OurWork;
